export default __webpack_public_path__ + "static/media/Group792.489ed5ce.svg";